import React, { useState, useEffect } from 'react';
import {
  FontDownload,
} from "@mui/icons-material";
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterItem,
  CharacterCustomItem,
  CharacterDeck,
  CharacterAbility,
  CharacterGem,
  CharacterAction,
  CharacterSpell,
  CharacterBook,
} from "@dndModels";
import {  
  RARITY_NUM_TO_COLOR_MAP, 
} from "@dndModels/Constants";

import API from "@dndUtilities/system_api";

import CharacterFeatureSourceInput from "@dndComponents/character/features/CharacterFeatureSourceInput";
import CharacterActionInput from "@dndComponents/character/spells_and_abilities/CharacterActionInput";
import CharacterSpellDetails from "@dndComponents/character/spells_and_abilities/CharacterSpellDetails";
import ChargesRefreshContol from "@dndComponents/character/misc/ChargesRefreshControl";
import CharacterItemScrollControls from "@dndComponents/character/inventory/CharacterItemScrollControls";
import CharacterCustomItemControls from "@dndComponents/character/inventory/CharacterCustomItemControls";
import CharacterNonCustomItemControls from "@dndComponents/character/inventory/CharacterNonCustomItemControls";
import CharacterGemControls from "@dndComponents/character/inventory/CharacterGemControls";
import CharacterDeckControls from "@dndComponents/character/inventory/CharacterDeckControls";
import StarBox from "@components/input/buttons/StarBox";
import CharacterItemBookControls from "@dndComponents/character/inventory/book/CharacterItemBookControls";
import CenteredMenu from "@components/input/menus/CenteredMenu";

interface Props {
  char: Character;
  char_item: CharacterItem;
  action?: CharacterAction;
  shared: boolean;
  onRemove: () => void;
}

const api = API.getInstance();

export default function CharacterItemDetailsSidebar({
  char,
  char_item,
  action,
  shared,
  onRemove
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [ping, setPing] = useState(false);
  const [view, setView] = useState(action && action.name !== char_item.name ? action.name : "");

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  // const enabled = api.user && (character.owner_id === api.user._id || (character.campaign !== null && character.campaign.owner_id === api.user._id));
  
  const renderActions = () => {
    // debugger;
    if (action && action.action instanceof CharacterAbility) {
      return (
        <Grid
          size={{
            xs: 12
          }}>
          <CharacterSpellDetails
            char_int={char}
            obj={ action.action }
            level={ action.level }
            type={action.type}
            action={action}
            shared={shared}
            onObjChange={(obj: CharacterSpell | CharacterAbility) => {
            }}
            onClose={() => {
            }}
          />
        </Grid>
      );
    } else {
      const filtered = char.actions.filter(o => 
        (o.action instanceof CharacterAbility &&
          o.action.item_id === char_item.true_id) || 
        (o.action instanceof CharacterItem &&
          o.action.true_id === char_item.true_id)
      );
      if (filtered.length > 0) {
        // group by casting time in, and label them by it
        const attacks = filtered.filter(o => o.casting_time === "Attack");
        const light_attacks = filtered.filter(o => o.casting_time === "Light Attack");
        const actions = filtered.filter(o => o.casting_time === "A");
        const bonus_actions = filtered.filter(o => o.casting_time === "BA");
        const reactions = filtered.filter(o => o.casting_time === "RA");
        const other = filtered.filter(o => o.casting_time !== "A" && o.casting_time !== "BA" && o.casting_time !== "RA" && !o.casting_time.includes("Attack"));
        return (
          <Grid
            container
            spacing={0}
            direction="row"
            size={{
              xs: 12
            }}>
            { attacks.length > 0 &&
              <>
                <Grid
                  style={{
                    fontSize: "14px",
                  }}
                  className={`header`}
                  size={{
                    xs: 12
                  }}>
                  &nbsp;Attacks
                </Grid>
                { attacks.map((action, key: number) => {
                  if (reloading) {
                    return (<span key={key}></span>);
                  } else {
                    return (
                      <Grid
                        key={key}
                        size={{
                          xs: 12
                        }}>
                        <CharacterActionInput
                          char_int={char}
                          action={action}
                          processing={false}
                          shared={false}
                          level={action.level}
                          onOpen={() => {}}
                        />
                      </Grid>
                    );
                  }
                })}
              </>
            }
            { light_attacks.length > 0 &&
              <>
                <Grid
                  style={{
                    fontSize: "14px",
                  }}
                  className={`header`}
                  size={{
                    xs: 12
                  }}>
                  &nbsp;Light Attacks
                </Grid>
                { light_attacks.map((action, key: number) => {
                  if (reloading) {
                    return (<span key={key}></span>);
                  } else {
                    return (
                      <Grid
                        key={key}
                        size={{
                          xs: 12
                        }}>
                        <CharacterActionInput
                          char_int={char}
                          action={action}
                          processing={false}
                          shared={false}
                          level={action.level}
                          onOpen={() => {}}
                        />
                      </Grid>
                    );
                  }
                })}
              </>
            }
            { actions.length > 0 &&
              <>
                <Grid
                  style={{
                    fontSize: "14px",
                  }}
                  className={`header`}
                  size={{
                    xs: 12
                  }}>
                  &nbsp;Actions
                </Grid>
                { actions.map((action, key: number) => {
                  if (reloading) {
                    return (<span key={key}></span>);
                  } else {
                    return (
                      <Grid
                        key={key}
                        size={{
                          xs: 12
                        }}>
                        <CharacterActionInput
                          char_int={char}
                          action={action}
                          processing={false}
                          shared={false}
                          level={action.level}
                          onOpen={() => {}}
                        />
                      </Grid>
                    );
                  }
                })}
              </>
            }
            { bonus_actions.length > 0 &&
              <>
                <Grid
                  style={{
                    fontSize: "14px",
                  }}
                  className={`header`}
                  size={{
                    xs: 12
                  }}>
                  &nbsp;Bonus Actions
                </Grid>
                { bonus_actions.map((action, key: number) => {
                  if (reloading) {
                    return (<span key={key}></span>);
                  } else {
                    return (
                      <Grid
                        key={key}
                        size={{
                          xs: 12
                        }}>
                        <CharacterActionInput
                          char_int={char}
                          action={action}
                          processing={false}
                          shared={false}
                          level={action.level}
                          onOpen={() => {}}
                        />
                      </Grid>
                    );
                  }
                })}
              </>
            }
            { reactions.length > 0 &&
              <>
                <Grid
                  style={{
                    fontSize: "14px",
                  }}
                  className={`header`}
                  size={{
                    xs: 12
                  }}>
                  &nbsp;Reactions
                </Grid>
                { reactions.map((action, key: number) => {
                  if (reloading) {
                    return (<span key={key}></span>);
                  } else {
                    return (
                      <Grid
                        key={key}
                        size={{
                          xs: 12
                        }}>
                        <CharacterActionInput
                          char_int={char}
                          action={action}
                          processing={false}
                          shared={false}
                          level={action.level}
                          onOpen={() => {}}
                        />
                      </Grid>
                    );
                  }
                })}
              </>
            }
            { other.length > 0 &&
              <>
                <Grid
                  style={{
                    fontSize: "14px",
                  }}
                  className={`header`}
                  size={{
                    xs: 12
                  }}>
                  &nbsp;Special
                </Grid>
                { other.map((action, key: number) => {
                  if (reloading) {
                    return (<span key={key}></span>);
                  } else {
                    return (
                      <Grid
                        key={key}
                        size={{
                          xs: 12
                        }}>
                        <CharacterActionInput
                          char_int={char}
                          action={action}
                          processing={false}
                          shared={false}
                          level={action.level}
                          onOpen={() => {}}
                        />
                      </Grid>
                    );
                  }
                })}
              </>
            }
          </Grid>
        );
      }
    }
    return null;
  }

  const renderItemDetails = () => {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className="header centered"
          size={{
            xs: 12
          }}>
          <span style={{ color: RARITY_NUM_TO_COLOR_MAP[char_item.rarity] }}>
            { char_item.name }&nbsp;
          </span>
          { char_item.attuned && <FontDownload fontSize="inherit" /> }
        </Grid>
        <Grid
          size={{
            xs: 6
          }}>
          <StarBox
            name="Favorite"
            value={char_item.favorite}
            onChange={(changed: boolean) => {
              char_item.favorite = changed;
              char.changed();
              setPing(!ping);
            }}
          />
        </Grid>
        { char_item.item_type === "Custom" && char_item instanceof CharacterCustomItem ? 
          <Grid
            size={{
              xs: 12
            }}>
            <CharacterCustomItemControls
              character={char}
              char_item={char_item}
              onRemove={onRemove}
            />
          </Grid>
        :
          <Grid
            size={{
              xs: 12
            }}>
            <CharacterNonCustomItemControls
              character={char}
              char_item={char_item}
              onRemove={onRemove}
            />
          </Grid>
        }
        { char_item instanceof CharacterDeck && char_item.deck_id !== "" && 
          <CharacterDeckControls
            character={char}
            char_item={char_item}
          />
        }
        { char_item instanceof CharacterGem &&
          <CharacterGemControls
            character={char}
            char_item={char_item}
          />
        }
        { char_item.item_type === "Scroll" && char_item.extra_spell && 
          <CharacterItemScrollControls 
            character={char} 
            char_item={char_item} 
            shared={shared} 
            onRemove={onRemove}
          />
        }
        { char_item instanceof CharacterBook && 
          <CharacterItemBookControls 
            character={char} 
            char_book={char_item} 
            shared={shared} 
          />
        }
        { char_item.item_type !== "Potion" && char_item.item_type !== "Scroll" && char_item.item_type !== "Dust" && char_item.max_charges > 0 &&
          <Grid
            size={{
              xs: 12
            }}>
            <ChargesRefreshContol 
              character={char} 
              char_interface={char} 
              char_item={char_item} 
            />
          </Grid>
        }
        { char_item.equipped && (char_item.all_char_feature_bases.length > 0) &&
          <Grid
            size={{
              xs: 12
            }}>
            <CharacterFeatureSourceInput 
              char={char}
              source={char_item}
            />
          </Grid>
        }
      </Grid>
    );
  }

  console.log("Rendering Char View Inv");
  // debugger;
  if (action && action.name !== char_item.name) {
    const options: string[] = [action.name, char_item.name];

    return (
      <div 
        style={{ 
          height: "100%",
          overflowX: "hidden",
          padding: "4px",
          fontSize: "11px"
        }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <CenteredMenu 
              selected={view}
              options={options}
              onSelect={setView}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            { view === action.name && renderActions() }
            { view === char_item.name && renderItemDetails() }
          </Grid>
        </Grid>
      </div>
    );
  } else {
    return (
      <div 
        style={{ 
          height: "100%",
          overflowX: "hidden",
          padding: "4px",
          fontSize: "11px"
        }}>
        { renderItemDetails() }
      </div>
    );
  }
}
